export default "__VITE_ASSET__c80f9414__"